import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as MuzoneWaveMark } from '../../../images/muzone-wave-mark.svg';

import './Logo.scss';

export function Logo({ variant, className }) {
    const isStacked = variant === 'stacked';
    const isInline = variant === 'inline';
    const showMark = isStacked || isInline;
    return (
        <div
            className={[
                'header-logoIcon',
                isStacked ? 'header-logoIcon--stacked' : '',
                isInline ? 'header-logoIcon--inline' : '',
                className,
            ].filter(Boolean).join(' ')}
        >
            {showMark && (
                <MuzoneWaveMark className="header-logo-mark" aria-hidden="true" focusable="false" />
            )}
            <div className="header-logo-name">MUZONE</div>
        </div>
    );
}

Logo.propTypes = {
    variant: PropTypes.oneOf(['text', 'stacked', 'inline']),
    className: PropTypes.string,
};

Logo.defaultProps = {
    variant: 'text',
    className: '',
};
